export const getListHeight = ({maxHeight = 0, totalSize = 0, groupSize = 0, optionHeight = 1, groupHeaderHeight = 1}) =>
  Math.min(maxHeight, totalSize * optionHeight - groupSize * Math.abs(optionHeight - groupHeaderHeight));

export const getListWidth = ({maxWidth = 0, totalSize = 0, groupSize = 0, optionWidth = 1, groupHeaderWidth = 1}) =>
  Math.min(maxWidth, totalSize * optionWidth - groupSize * Math.abs(optionWidth - groupHeaderWidth));
